import { arrayOf, exact, string } from 'prop-types';

import { LatLngType } from './point.type';

export const RegionType = exact({
  id: string.isRequired,
  label: string.isRequired,
  latlng: LatLngType.isRequired,
});

export const RegionsType = arrayOf(RegionType);
